(function () {
  'use strict';

  // Mobile menu
  var toggle = document.querySelector('[data-nav-toggle]');
  var nav = document.getElementById('HeaderNav');
  if (toggle && nav) {
    toggle.addEventListener('click', function () {
      var open = nav.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  // Product gallery
  document.querySelectorAll('[data-gallery]').forEach(function (g) {
    var slides = g.querySelectorAll('[data-slide]');
    var thumbs = g.querySelectorAll('[data-thumb]');
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        var i = t.getAttribute('data-thumb');
        slides.forEach(function (s) { s.classList.toggle('is-active', s.getAttribute('data-slide') === i); });
        thumbs.forEach(function (x) { x.classList.toggle('is-active', x === t); });
      });
    });
  });

  // Quantity stepper
  document.querySelectorAll('[data-qty]').forEach(function (q) {
    var input = q.querySelector('input');
    var min = parseInt(input.min || '1', 10), max = parseInt(input.max || '99', 10);
    q.querySelector('[data-qty-minus]').addEventListener('click', function () {
      input.value = Math.max(min, (parseInt(input.value, 10) || 1) - 1);
    });
    q.querySelector('[data-qty-plus]').addEventListener('click', function () {
      input.value = Math.min(max, (parseInt(input.value, 10) || 1) + 1);
    });
  });

  // Sticky buy bar on mobile: show once the main buy button has scrolled out of view
  var bar = document.querySelector('[data-sticky-atc]');
  var buy = document.getElementById('buy-now');
  if (bar && buy && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      var e = entries[0];
      var show = !e.isIntersecting && e.boundingClientRect.top < 0;
      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
    }).observe(buy);
  }
})();
